import React from 'react'
import {Link} from 'react-router'
import styles from './NavbarSection.scss'

export class NavbarSection extends React.PureComponent {
  render () {
    return (
      <div className={styles.NavbarSection}>
        <h1>Navbar</h1>
        <p>
          <Link to='/styleguide/navbar_demo'>Open Navbar Demo in Fullscreen &raquo;</Link>
        </p>
      </div>
    )
  }
}

export {NavbarDemo} from './NavbarDemo'
